import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

import { reformatLot } from '../../../selectors/lots'

const initial = {
  donations: [],
  lots: [],
  persons: []
}

const lotsActions = generateActions('funds/fund/GET_LOTS')
const fixedpricelotsActions = generateActions('funds/fund/GET_FIXEDPRICELOTS')
const personsActions = generateActions('funds/fund/GET_PERSONS')
const fixedpricelotspersonsActions = generateActions('funds/fund/GET_FIXEDPRICELOTSPERSONS')

export const clear = createAction('funds/fund/CLEAR')

export const getLots = createAction(API_CONST, fundId => ({
  actions: lotsActions,
  url: `funds/${fundId}/lots`
}))

export const getFixedPriceLots = createAction(API_CONST, fundId => ({
  actions: fixedpricelotsActions,
  url: `funds/${fundId}/fixedpricelots`
}))

export const getPersons = createAction(API_CONST, fundId => ({
  actions: personsActions,
  url: `funds/${fundId}/persons`
}))

export const getFixedpriceLotsPersons = createAction(API_CONST, fundId => ({
  actions: fixedpricelotspersonsActions,
  url: `funds/${fundId}/fixedpricelotspersons`
}))

//
export function reformatPersons (items){
  var lots = []
items.map((item) => {
  let stats = item.bidsStats[0] || {}
    lots.push (
    {
    _id: item._id,
    name: item.name,
    targetId: item._id,
    date: stats.lastDate,
    sum: stats.fullSum,
    currency: item.bidsStats.currencySymbol
  })
  item.repeatedVisits.map((visit, i) => {    
    lots.push({
      _id: visit._id,
      name: item.name,
      targetId: item._id,
      date: stats.lastDate,
      sum: visit.value,
      currency: item.bidsStats.currencySymbol
    })
  })
})
  return lots
}

export default handleActions({
  [clear]: state => ({ ...initial }),
  [lotsActions[1]]: (state, { payload = [] }) => ({
    ...state,
    lots: payload.map(el => reformatLot(el))
  }),
  [fixedpricelotsActions[1]]: (state, { payload = [] }) => ({
    ...state,
	fixedpricelots: payload.map(el => reformatLot(el))
  }),
  [personsActions[1]]: (state, { payload = [] }) => ({
    ...state,
    persons: reformatPersons(payload)
  }),
  [fixedpricelotspersonsActions[1]]: (state, { payload = [] }) => ({
    ...state,
    fixedpricelotspersons: reformatPersons(payload)
  })
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/funds/fund.js